function BonusChoose({
  iconSrc = "/icon/casino_w_b_icon.png",
  bonusName = "Casino welcome bonus",
  bonusText = null,
  onClick = () => {},
  active = false,
}) {
  const bonText = bonusText ? (
    <h3 className='bonus-text'>{bonusText}</h3>
  ) : null;
  return (
    <div className='bonus-choose' onClick={onClick}>
      <img className='icon' src={iconSrc} alt='Bonus icon' />
      <label>
        <span>{bonusName}</span>
        {bonText}
      </label>
      <div className={`status ${active ? "active" : ""}`} />
    </div>
  );
}
export default BonusChoose;